import React from "react";
import { FILE_UPLOAD_IMG, PLUS_ICON, SEARCHICON } from "../../../utills/image-constant";
import DropDownWithLabel from "./DropDownWithlable";

const SearchAndAddItem = ({
  title = "",
  searchValue,
  onSearchChange,
  data,
  addButtonClick,
  permissionAccessbtn = "",
  labelName,
  lableclassName,
  name,
  options,
  value,  // Change defaultValue to value
  handleSelect,
  className = "",
  disabled = false,
  showDropdown = false,
  showuploadbtn = false,
  uploadButtonClick,
  setIsModalOpen,
  isModalOpen,
  clearbtn = false,
  handleClear = () => { },

  // 🔹 New Props for Resend Link Button
  showResendButton = false,
  onResendClick = () => { },
  resendButtonDisabled = false,
}) => {
  return (
    <div className="row mb-3 px-3 align-items-center">
      <div className="col-md-12 col-lg-4 ps-0">
        <h5 className="mb-md-0 mb-2">{title}</h5>
        {showDropdown && (
          <div className="dropdown-container companyemployeedropdown mb-md-3 mb-lg-0">
            <label className={lableclassName}>{labelName}</label>
            <select
              name={name}
              className={`form-select ${className}`}
              value={value}  // Use value instead of defaultValue
              onChange={(e) => handleSelect(e)}  // Pass the selected value to handleSelect
              aria-label={labelName}
              disabled={disabled}
            >
              <option value="">Select</option>
              {options?.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>

      <div className="col-12 col-lg-2 p-md-0">
        {clearbtn && (
          <button
            className="border-0 bg-primary text-white rounded-2 p-1 clearall-btn w-100 textfont12 mb-3 mb-lg-0"
            onClick={handleClear}
          >
            Clear
          </button>
        )}
      </div>

      <div className="col-md-12 col-lg-6 d-flex justify-content-lg-end justify-content-start pe-0 p-md-0">
        <div className="d-flex flex-wrap">
          {/*  Search Input */}
          <div className="position-relative me-2">
            <img src={SEARCHICON} alt="..." className="img-fluid searchicon" />
            <input
              required
              type="text"
              name="search"
              value={searchValue}
              onChange={onSearchChange}
              className="form-control tablesearch mb-md-0 mb-2"
              placeholder="Search"
            />
          </div>

          {/*  Bulk Upload */}
          {showuploadbtn && (
            <button
              className="border-0 bg-primary text-white rounded-2 p-1 me-2 px-3 addmodal mb-md-0 mb-2"
              onClick={() => {
                setIsModalOpen(true);
              }}
            >
              Bulk Upload{" "}
              <span>
                <img src={FILE_UPLOAD_IMG} alt="" className="plusicon" />
              </span>
            </button>
          )}

          {/*  Add Button */}
          {permissionAccessbtn === 1 && (
            <button
              className="border-0 bg-primary text-white rounded-2 p-1 px-3 addmodal mb-md-0 mb-2"
              onClick={addButtonClick}
            >
              Add {data}{" "}
              <span>
                <img src={PLUS_ICON} alt="" className="plusicon" />
              </span>
            </button>
          )}

          {showResendButton && (
            <button
              onClick={onResendClick}
              disabled={resendButtonDisabled}
              className="border-0 rounded-2 p-1 px-3 addmodal mb-md-0 mb-2"
              style={{
                backgroundColor: resendButtonDisabled ? "#c0c0c0" : "#007bff", // gray when disabled, blue when active
                color: resendButtonDisabled ? "#6c757d" : "#fff",
                cursor: resendButtonDisabled ? "not-allowed" : "pointer",
                opacity: resendButtonDisabled ? 0.7 : 1,
              }}
            >
              Resend Link
            </button>
          )}

        </div>
      </div>
    </div>
  );
};

export default SearchAndAddItem;
